export const environment = {
  env: 'PROD',
  production: true,
  //serverBaseUrl: 'http://bkcajasistem.vaixs.org/public/api',
  // serverBaseUrl: 'http://bkgamvinto.appsbo.com/public/api',
  // serverUrl: 'http://bkgamvinto.appsbo.com/public/api',
  // imgUrl: 'http://bkgamvinto.appsbo.com/public',
  serverBaseUrl: 'https://gamvinto.gob.bo/bkweb/public/api',
  serverUrl: 'https://gamvinto.gob.bo/bkweb/public/api',
  imgUrl: 'https://gamvinto.gob.bo/bkweb/public'
  // serverBaseUrl: 'http://bkgobernacion.appsbo.com/public/api',
  // serverUrl: 'http://bkgobernacion.appsbo.com/public/api',
  // imgUrl: 'http://bkgobernacion.appsbo.com/public'


};
